// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper-a9brEM{flex-direction:column;width:100%;display:flex}.input-wrapper-a9brEM>*,.input-wrapper-a9brEM span{width:100%}.error-content-yl1WPm{height:20px}.error-float-Kr8qU7{width:100%;position:absolute}.error-text-p2XNVV{color:var(--semi-color-danger);font-family:SF Pro Display,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:22px}.input-zBTotH input{text-overflow:ellipsis;overflow:hidden}.limit-count-UBFzWU{color:var(--light-usage-text-color-text-3,rgba(28,31,35,.35));padding-left:8px;padding-right:12px;font-size:12px;font-style:normal;font-weight:400;line-height:16px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `input-wrapper-a9brEM`,
	"inputWrapper": `input-wrapper-a9brEM`,
	"error-content": `error-content-yl1WPm`,
	"errorContent": `error-content-yl1WPm`,
	"error-float": `error-float-Kr8qU7`,
	"errorFloat": `error-float-Kr8qU7`,
	"error-text": `error-text-p2XNVV`,
	"errorText": `error-text-p2XNVV`,
	"input": `input-zBTotH`,
	"limit-count": `limit-count-UBFzWU`,
	"limitCount": `limit-count-UBFzWU`
};
export default ___CSS_LOADER_EXPORT___;
